import AsyncSelect from 'react-select/async';
import { getRandomUid } from 'utilities/uuid.service';
import { useContext, useState } from 'react';
import { FetchContext } from 'context/FetchContext';

function UserSelect({
  enableAPI,
  isMulti,
  values,
  handleChange,
  dependencies = {},
  hideLabel = false,
  isClearable = false,
  classNamePrefix = ``,
}) {
  const { query = {} } = dependencies;
  const [searchQuery, setSearchQuery] = useState('');

  const _id = getRandomUid();

  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  let abortController;

  async function loadOptions() {
    if (abortController) abortController.abort();

    abortController = new AbortController();

    const { data = {} } = await privateFetch
      .get(`/v1/admin/user/search`, {
        params: { ...query, keyword: searchQuery },
        signal: abortController.signal,
      })
      .then((res) => res.data);

    return data?.result ?? [];
  }

  return (
    <>
      {hideLabel === false && <label htmlFor={_id}></label>}
      <AsyncSelect
        styles={{
          control: (baseStyles, state) => ({
            ...baseStyles,
            borderColor: '#e9baf0',
            'box-shadow': '0 0.8rem 1.2rem rgba(20, 102, 204, 0.14)',
          }),
        }}
        inputId={_id}
        isMulti={isMulti}
        cacheOptions
        isClearable={isClearable}
        onChange={handleChange}
        value={values}
        onInputChange={(input) => setSearchQuery(input)}
        loadOptions={loadOptions}
        getOptionLabel={(user) => user.name}
        getOptionValue={(user) => user._id}
        placeholder="Search for users here..."
        classNamePrefix={classNamePrefix}
      />
    </>
  );
}

UserSelect.defaultProps = {
  values: [],
  isMulti: true,
  handleChange: () => {},
};

export default UserSelect;
